import interceptedAxios from '../../../utils/interceptedAxios'
import LanguageStrings from '../../../i18n/locales'

export async function getDeviceList (
  PageNumber: number,
  PageItems: number,
  searchKey: string,
  SortParams: string,
  sortField: string,
  onSuccess: (customDeviceList: any, httpStatus: number) => any,
  onFailure: (errorMessage: any, httpStatus: number) => any
): Promise<void> {
  const DeviceManagementStrings = LanguageStrings().DeviceManagementCollectionStrings.TableComponent
  const Sorting = (sortField !== '' && sortField != null) ? `${sortField},${SortParams}` : 'modifiedAt,desc'
  const url = `/asset-config-service/api/v1/udp/tiq/commands/configuration/device-template/details?page=${PageNumber - 1}&search=${searchKey}&size=${PageItems}&sort=${Sorting}`
  interceptedAxios.get(url, { timeout: 15000 })
    .then((response) => {
      const parseResponse = response.data
      if (parseResponse.error === false) {
        if (parseResponse.data !== null && parseResponse.data !== undefined) {
          onSuccess(parseResponse.data, parseResponse.http_status)
        } else {
          onFailure(parseResponse.error, parseResponse.http_status)
        }
      } else {
        onFailure(parseResponse.error.message, response.status)
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        onFailure((error.response.data !== undefined && error.response.data !== null) ? error.response.data.error_message : DeviceManagementStrings.NetworkError, error.response.status)
      } else {
        onFailure(DeviceManagementStrings.NetworkError, 404)
      }
    })
}
